export default "__VITE_ASSET__DHKVpLmN__";